module.exports = __webpack_public_path__ + "static/media/Portfolio_full.47a9df41.JPG";